module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxjaXJjbGUgY3g9IjEyIiBjeT0iMTIiIHI9IjkiIHN0cm9rZT0iI0Y1OTYzOCIgc3Ryb2tlLXdpZHRoPSIyIi8+DQo8cGF0aCBkPSJNMTIuNSA3LjVDMTIuNSA3Ljc3NjE0IDEyLjI3NjEgOCAxMiA4QzExLjcyMzkgOCAxMS41IDcuNzc2MTQgMTEuNSA3LjVDMTEuNSA3LjIyMzg2IDExLjcyMzkgNyAxMiA3QzEyLjI3NjEgNyAxMi41IDcuMjIzODYgMTIuNSA3LjVaIiBmaWxsPSIjRjU5NjM4IiBzdHJva2U9IiNGNTk2MzgiLz4NCjxwYXRoIGQ9Ik0xMiAxN1YxMCIgc3Ryb2tlPSIjRjU5NjM4IiBzdHJva2Utd2lkdGg9IjIiLz4NCjwvc3ZnPg0K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/icon-blocked-entry.svg
// module id = 115
// module chunks = 1